import React from "react";
import { MdCancel } from "react-icons/md";
import { useSelector } from "react-redux";
import "./GuidePage.css";
const GuidePage = (props) => {
  const lang = useSelector((state) => state.reducer1.lang);
  const mode = useSelector((state) => state.reducer1.mode);
  const [n, setN] = React.useState(1);

  const heading = [
    "",
    "How to enjoy Regionport!",
    "How to enjoy Regionport!",
    "How to enjoy Regionport!",
    "How to enjoy Regionport!",
  ];
  const desc = [
    "",
    "Welcome to Regionport World! On this site, you can experience event information and local attractions in each area at the foot of Mt. Fuji.",
    "Explore each area and enjoy animated event introductions, the latest news, and original art.",
    "The header provides detailed information about Regionport, and the footer provides the latest events and social media links so you can connect with Regionport.",
    "Check the latest event information and easily reserve for the event you want to attend. For details of the event and how to reserve, please check the event page.",
  ];
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        zIndex: "1001",
        width: "100vw",
        height: "100vh",
        // border:"2px solid red"
      }}
    >
      <nav style={{ display: "flex" }}>
        <div style={{ display: "grid", placeItems: "center" }}>
          {mode == "day" ? (
            <img src="/img/logo-b.png" alt="" />
          ) : (
            <img src="/img/logo-w.png" alt="" />
          )}
          {lang === "en" ? (
            <p
              className="klee-one-regular"
              style={{
                color: mode == "day" ? "black" : "white",
                fontSize: ".8rem",
                position: "relative",
              }}
            >
              - Make the Region -
            </p>
          ) : (
            <p
              className="klee-one-regular"
              style={{ color: "black", fontSize: ".8rem" }}
            >
              - 地域をより良い明日に -
            </p>
          )}
        </div>

        <div
          className="cancelBtn"
          style={{ color: "white" }}
          onClick={() => {
            // setTimeout(() => {
            props.cancelGuide();
            // }, 400);
            document.getElementById("main").className = "animateAboutClose";
          }}
        >
          <MdCancel />
        </div>
      </nav>


      <main
        id="guideMain"
        style={{
          display: "grid",
          placeItems: "center",
          position: "relative",
          backgroundColor: "white",
          fontFamily: "Manjari, sans-serif",
          fontWeight: "700",
          fontStyle: "normal",
          borderRadius: "20px",
          // border:"5px solid blue"
        }}
        >
        <div
          style={{
            display: "grid",
            // border:"5px solid red",
            placeItems: "center",
            position: "relative",
            width: "100%",
          }}
        >
          <p
          className="num"
            style={{
              color: "gray",
              position: "absolute",
              top: "0",
              left: "0",
            }}
          >
            0{n}/04
          </p>
          <h2 className="heading">{heading[n]}</h2>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            // border:"5px solid lime"
          }}
        >
          <button
          className="btn"
            onClick={() => {
              if (n > 1) {
                setN(n - 1);
              }
            }}
            style={{
              color: "white",
              backgroundColor: "#44496f",
              border: "none",
              cursor: "pointer",
              borderRadius: "10px",
            }}
          >
            &larr;
          </button>

          <img
            className="img"
            src={`img/g${n}.png`}
            alt="guide-image"
          />

          <button
                    className="btn"

            onClick={() => {
              if (n < 4) {
                setN(n + 1);
              }
            }}
            style={{
              color: "white",
              backgroundColor: "#44496f",
              border: "none",
              cursor: "pointer",
              borderRadius: "10px",
            }}
          >
            &rarr;
          </button>
        </div>

        <div className="desc">
          {desc[n]}
        </div>
      </main>
    </div>
  );
};

export default GuidePage;
